import {reamazeAuthService} from '_services';
import {oauthConstants, alertMessages, toastMessage} from "_constants";
import {SnackBar} from "components/common";
import {history} from "_helpers";
import {Toast} from "../components/v3/common/Toast";

function verifyKey(params){
    function request() {
        return {type: oauthConstants.REAMAZE_AUTH_REQUEST};
    }

    function success(payload) {
        return {type: oauthConstants.REAMAZE_AUTH_SUCCESS, payload};
    }

    function failure() {
        return {type: oauthConstants.REAMAZE_AUTH_FAILURE}
    }

    return (dispatch) => {
        dispatch(request());

        reamazeAuthService.verifyApiKey(params)
            .then(
                (res) => {
                    dispatch(success(res));
                    history.push('/company/channels')
                    const {successMessage, options} = toastMessage.connectChannel;
                    Toast.showMessage(successMessage, options);
                },
                (error) => {
                    dispatch(failure(error));
                    SnackBar.showMessage(alertMessages.REAMAZE_AUTH_FAILURE)
                },
            );
    };
}

export const reamazeAuthActions = {
    verifyKey
}
